import { PulseLoader } from 'react-spinners'
import styled, { useTheme } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${({ theme }) => theme.padding(1)};
`

export default function PulseLoaderComponent({ customColor }: { customColor?: string }) {
  const theme = useTheme()
  return (
    <Wrapper>
      <PulseLoader color={customColor ? customColor : theme.colors.secondary} />
    </Wrapper>
  )
}
